import { Testimonial } from '../types/testimonial';

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'angie-duarte',
    quote:
      'Una experiencia espectacular. Un lugar muy agradable y tranquilo, especial para desconectarse del día a día y relajarse en la naturaleza. El servicio fue impecable y muy especiales, abiertos a ayudarnos y suplir todas las necesidad. La comida increíble y el ambiente 15/10. Si tienen la posibilidad de ir, no la desaprovechen!',
    authorInitial: 'A',
    authorName: 'Angie Duarte',
    authorLocation: 'Hace 7 meses en Google',
  },
  {
    id: 'carlos-sofia',
    quote:
      'Fuimos con nuestra mascota y fue la mejor decisión. Todo el equipo nos recibió con mucho cariño. La cabaña Bilibil es perfecta para una escapada romántica, la piscina privada y la vista a las montañas son inmejorables. ¡Súper recomendado!',
    authorInitial: 'C',
    authorName: 'Carlos M.',
    authorLocation: 'Hace 2 meses en Google',
  },
  {
    id: 'andres',
    quote:
      'El Luxury Saman nos dejó sin palabras. Éramos un grupo grande y todos quedamos enamorados de las instalaciones. El sauna, la piscina y la atención del personal hacen que la estadía sea un 10/10. Definitivamente volveremos.',
    authorInitial: 'J',
    authorName: 'Juan Pablo R.',
    authorLocation: 'Hace 4 meses en Google',
  },
];
